import React from 'react';
import { TextField } from '@material-ui/core';
import { useField, FieldConfig } from 'formik';

const InputSimple = ({ name, ...OtherProps }) => {
  const [field, mata] = useField(name);

  const configTextField = {
    ...field,
    ...OtherProps,
    fullWidth: true,
    size: 'small',
    variant: 'standard'
  };

  if (mata && mata.touched && mata.error) {
    configTextField.error = true;
    configTextField.helperText = mata.error;
  }

  return <TextField {...configTextField} />;
};

export default InputSimple;
